<template>
  <div>
    <base-header class="pb-8 pt-4" />
    <div class="container-fluid mt--7">
      <b-card no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div class="col d-flex align-items-center justify-content-between">
              <h3 class="card-title mb-0">{{ $t("Terzideki Ürünler") }}</h3>
              <h3>

                <div class="d-flex">
                  <b-form-group class="mb-0 mr-2">
                    <b-form-select v-model="filterType" :options="[
                    { text: 'Terzideki Ürünler', value: 'now' },
                    { text: 'Geçmişde terziye verilenler', value: 'past' },
                    { text: 'Gelecekte terziye verilecekler', value: 'future' },
                  ]" @change="refreshTable" />
                  </b-form-group>

                  <b-button variant="primary" :to="{ 'name':'create-tailor-product'}"> {{ $t("Terziye Ürün Gönder") }}! </b-button>
                </div>
              </h3>
            </div>
          </div>
        </b-card-header>

        <b-table ref="table" class="align-items-center" thead-class="thead-light" :fields="fields" :items="getItems" responsive show-empty>

          <template v-slot:table-busy>
            <div style="width: 100%; text-align:center;">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:empty>
            <b-alert variant="warning" show>{{ $t("Henüz bir şey eklenmemiş") }}!</b-alert>
          </template>

          <template v-slot:cell(actions)="data">
            <!--            <b-button variant="outline-success" @click="paymentModal(data.item.id)">+ Ödeme Gir</b-button>-->
            <b-button variant="warning" v-if="data.item.status=='active'"   @click="releaseModal(data.item.id)">{{
                $t("Teslim Al")
              }} </b-button>
          </template>

        </b-table>
      </b-card>
    </div>

    <b-modal ref="releaseModal" title="Teslim Al" @hide="hidePaymentModal">
      <b-form-group>
        <label>Teslim alınan tarih</label>
        <b-form-input v-model="releaseData.delivered_date" type="date" />
      </b-form-group>
      <b-form-group>
        <label>Ödenen Tutar</label>
        <b-form-input v-model="releaseData.price" type="number" />
      </b-form-group>
<!--      <b-form-checkbox v-model="releaseData.clear_credits">Bu kiranın (varsa) kalan ödemelerini tamamla.</b-form-checkbox>-->
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="$refs.releaseModal.hide()">{{ $t("İptal") }}</b-button>
        <b-button variant="primary" @click="releaseAction">{{ $t("Teslim Al") }}</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from "moment";

export default {
  data () {
    return {
      filterType:'now',
      releaseData: {},
      paymentData: {
        payment_date: moment().format('YYYY-MM-DD'),
      },
      fields: [
        { key: 'client.full_name', label: 'Terzi Adı' },
        { key: 'client.gsm', label: 'Telefonu' },
        { key: 'service.name', label: 'Ürün Adı' },
        { key: 'issue_date', label: 'Alış Tarihi' },
        { key: 'delivery_date', label: 'Teslim Edildiği Tarih' },
        // { key: 'price', label: 'Peşinat' },
        { key: 'price', label: 'Toplam Ücret' },
        { key: 'actions', label: '', tdClass: 'text-right' },
      ],
    }
  },
  methods: {
    ...mapActions(['getTailorProducts', 'createPayment', 'releaseTailor']),
    releaseAction() {
      this.releaseTailor(this.releaseData).then(response => {
        this.success(response.data.message);
        this.$refs.releaseModal.hide();
        this.refreshTable();
      }).catch(error => {
        this.error(error.response.data.message);
      })
    },
    releaseModal(id) {
      this.releaseData = {
        delivered_date: moment().format('YYYY-MM-DD'),
        lease_id: id,
      };
      this.$refs.releaseModal.show();
    },
    paymentAction() {
      this.createPayment(this.paymentData).then(response => {
        this.success(response.data.message);
        this.$refs.paymentModal.hide();
        this.refreshTable();
      }).catch(error => {
        this.error(error.response.data.message);
      });
    },
    paymentModal(id) {
      this.paymentData.lease_id = id;
      this.$refs.paymentModal.show();
    },
    hidePaymentModal() {
      this.paymentData = {
        payment_date: moment().format('YYYY-MM-DD'),
      };
    },
    refreshTable () {
      this.$refs.table.refresh()
    },
    getItems () {
      return this.getTailorProducts(this.filterType)
          .then(data => data.data).then(response => {
            return response;
          })
    },
  }
}
</script>
